// DEPENDENCIES
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
// COMPONENTS
import Table from 'react-bootstrap/Table';
import MUIDataTable from "mui-datatables";
import { VictoryBar, VictoryPie, VictoryChart, VictoryAxis, VictoryTheme, VictoryLegend, VictoryLabel } from 'victory';
import ImageGallery from 'react-image-gallery';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Chip } from '@material-ui/core';
import { Alert } from '../../helpers/Alert';
// ICONS
import { BiDollar } from 'react-icons/bi';
import { FormatListBulletedSharp } from '@material-ui/icons';
import { RiMailSendLine } from 'react-icons/ri';
import { FaCopy } from "react-icons/fa";
// CUSTOM COMPONENTS
import Section from '../../components/Section';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import Button from '../../components/Button';
import InputBlock from '../../components/InputBlock';
import MediaBlock from '../../components/MediaBlock';
import LoadingScreen from '../../components/LoadingScreen';
import HeaderBlock from '../../components/HeaderBlock';
import SelectBlock from '../../components/SelectBlock';
import SmallCard from '../../components/SmallCard';
// SERVICES AND HELPERS
import constants from '../../constants/constants';
import * as Helper from '../../helpers/helper';
import * as QuoteService from '../../services/quote.service';

const CampaignSummaryPage = (props) => {
    const loggedIn = Helper.IsUserLoggedIn();
    const [loading, setLoading] = useState(false);
    const { location } = props
    const hashId = location.pathname.split('/').pop();
    const [quote, setQuote] = useState(null);
    const [levelMonths, setLevelMonths] = useState(1);
    const [levelSpending, setLevelSpending] = useState(0);

    const [showSend, setShowSend] = useState(false);
    const [email, setEmail] = useState(null);
    const [sending, setSending] = useState(false);
    const [monthlySpendData, setMonthlySpendData] = useState([]);
    const durationOptions = Helper.GetMonthOptionsForDuration(12) ?? [];

    useEffect(() => {
        setLoading(true);
        QuoteService.GetQuoteSummaryData(hashId)
            .then(res => {
                setQuote(res);
                UpdateLevelMonthsAndSpending(res.bonusData.levelMonths ?? 1);
                setLevelSpending(res.bonusData.currentTotal / (res.bonusData.levelMonths ?? 1));
                setLoading(false);
                handleMonthlySpendData(res.products);
            }).catch(ex => {
                setLoading(false);
            });
    }, []);

    const handleMonthlySpendData = (products) => {
        const data = products.filter(x => x.months && !x.isBonus).map(x => ({ months: x.months, price: x.price }))
        const monthPriceMap = {};

        data.forEach(entry => {
            entry.months.split(',').forEach(month => {
                const trimmedMonth = month.trim();
                monthPriceMap[trimmedMonth] = (monthPriceMap[trimmedMonth] || 0) + entry.price;
            });
        });

        const result = Object.keys(monthPriceMap).map(month => ({ month, price: monthPriceMap[month] }));
        console.log('Result is ', result);
        const tempArr = [];
        durationOptions.forEach((duration) => {
            const obj = { month: duration };
            const findResult = result.find((x) => x.month === duration);
            obj['price'] = (findResult) ? findResult.price : 0

            tempArr.push(obj);
        });
        setMonthlySpendData(tempArr);
        // const inputMonths = result.map(entry => moment(entry.month, 'MMMM YYYY'));
        // const firstMonth = moment.min(inputMonths);
        // const allMonths = _.times(12, index => firstMonth.clone().add(index, 'months'));
        // const resultArray = allMonths.map(month => {
        //     const matchingEntry = result.find(entry => month.isSame(moment(entry.month, 'MMMM YYYY'), 'month'));
        //     return {
        //         month: month.format('MMMM YYYY'),
        //         price: matchingEntry ? matchingEntry.price : 0
        //     };
        // });

        // setMonthlySpendData(resultArray);
    };

    const UpdateLevelMonthsAndSpending = (months) => {
        setLevelMonths(months);
        setLevelSpending(quote ? quote.bonusData.currentTotal / months : 0);
    }

    const UpdateQuoteLevelMonths = (months) => {
        QuoteService.SaveQuoteLevelMonths(quote.id, months).then(res => { }).catch(ex => { });
    }

    let level = 1;
    const bonusBuyOptions = quote ? _.map(quote.companyBonusLevelData, function (x) { return { id: x.id, level: 'Level ' + level++, amount: x.breakpoint, percentage: x.reward } }) : [];
    const mediaLabels = quote ? _.map(quote.mediaUsageData, function (x) { return x.name }) : [];
    const mediaDistribution = quote ? _.map(quote.mediaUsageData, function (x) { return { id: x.id, media: x.name, percentage: x.distribution, label: `${x.distribution}%` } }) : [];
    const spendingDistribution = quote ? _.map(quote.mediaUsageData, function (x) { return { id: x.id, media: x.name, spent: x.totalSpending, label: `$${x.totalSpending}` } }) : [];
    const sampleImages = quote ? _.map(quote.productImages, function (x) { return { original: constants.API_URL + 'Attachments' + x.imagePath, thumbnail: constants.API_URL + 'Attachments' + x.imagePath } }) : []
    const normalBuys = quote ? _.filter(quote.products, x => x.isBonus == false && x.quantity > 0 && x.product.isActive) : [];
    const bonusBuys = quote ? _.filter(quote.products, x => x.isBonus == true && x.quantity > 0 && x.product.isActive) : [];

    const options = {
        selectableRows: "none",
        download: false,
        filter: false,
        print: false,
        search: false,
        sort: false,
        enableNestedDataAccess: '.'
    }

    const normalLogos = [
        {
            name: "",
            label: "Image",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    {
                        let primaryImage = _.find(normalBuys[dataIndex].product.productImage, x => x.isPrimary)
                        return (
                            <MediaBlock
                                source={primaryImage ? primaryImage.imagePath : ""}
                            />
                        );
                    }
                }
            }
        }
    ]

    const bonusLogos = [
        {
            name: "",
            label: "Image",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    {
                        let primaryImage = _.find(bonusBuys[dataIndex].product.productImage, x => x.isPrimary)
                        return (
                            <MediaBlock
                                source={primaryImage ? primaryImage.imagePath : ""}
                            />
                        );
                    }
                }
            }
        }
    ]

    const columns = [
        {
            name: "product.name",
            label: "Product",
            options: {
                filter: true,
                sort: false
            }
        },
        {
            name: "product.category.name",
            label: "Category",
            options: {
                filter: true,
                sort: false
            }
        },
        {
            name: "product.category.mediaType.name",
            label: "Media",
            options: {
                filter: true,
                sort: false
            }
        },
        {
            name: "quantity",
            label: "Quantity",
            options: {
                filter: true,
                sort: false
            }
        },
        {
            name: "price",
            label: "Price",
            options: {
                filter: true,
                sort: false
            }
        },
        {
            name: "months",
            label: "Months",
            options: {
                filter: true,
                sort: false
            }
        }
    ];

    const normalColumns = [
        {
            name: "total",
            label: "Total",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    let val = normalBuys[dataIndex].quantity * normalBuys[dataIndex].price;
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            }
        },
        {
            name: "product.audienceSize",
            label: "Audience Size",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    let val = normalBuys[dataIndex].quantity * normalBuys[dataIndex].product.audienceSize;
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            }
        }
    ];

    const bonusColumns = [
        {
            name: "total",
            label: "Total",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    let val = bonusBuys[dataIndex].quantity * bonusBuys[dataIndex].price;
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            }
        },
        {
            name: "product.audienceSize",
            label: "Audience Size",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    let val = bonusBuys[dataIndex].quantity * bonusBuys[dataIndex].product.audienceSize;
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
            }
        }
    ];

    const copyToClipboard = (textToCopy) => {
        // Use the Clipboard API if available
        if (navigator.clipboard) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    console.log('Text copied to clipboard');
                })
                .catch((err) => {
                    console.error('Unable to copy to clipboard', err);
                });
        } else {
            // Fallback for older browsers using document.execCommand
            const textarea = document.createElement('textarea');
            textarea.value = textToCopy;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            console.log('Text copied to clipboard');
        }

        Alert({ success: true, message: 'Link has been copied to clipboard!' });
    };

    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <>
                        <HeaderBlock
                            backgroundColor={"white--bg"}
                            toLeft={loggedIn ? "/dashboard" : ""}
                            noDrawer
                            companyLogo={quote && quote.companyLogo}
                        />
                        <CustomBlock className="main-container light--bg">
                            <Section>
                                <CustomBlock className="content-container--card-style campaign-summary-container">

                                    {/* CAMPAIGN HEADER */}
                                    <CustomBlock>
                                        <ContentHeader
                                            title="Campaign Summary"
                                            primaryButtonText={loggedIn ? "Copy Share Link" : ""}
                                            primaryButtonBackgroundColor="info--bg"
                                            primaryButtonOnClick={() => {
                                                // setShowSend(true);
                                                copyToClipboard(`http://app.thecampaignplanner.com/campaign-summary/${hashId}`);
                                            }}
                                            primaryButtonIconLeft={
                                                <FaCopy className="button-left-icon" />
                                            }
                                            secondaryButtonText={loggedIn ? "Back" : ""}
                                            secondaryButtonBackgroundColor="danger--bg"
                                            secondaryButtonOnClick={() => {
                                                props.history.push("/campaign/" + quote.id);
                                            }}
                                        />
                                    </CustomBlock>

                                    {/* TOTALS AND BONUS BUY MATRIX */}
                                    <CustomBlock className="totals-and-bonus-matrix-container">
                                        <CustomBlock className="bonus-matrix">
                                            <ContentHeader
                                                title="Bonus Buy"
                                                headerSize="md"
                                            />
                                            <CustomBlock className="quote-summary">
                                                <CustomBlock className="item-summary-header">
                                                    <p className="item-header item-name-header">Level</p>
                                                    <p className="item-header item-name-header">Breakpoint</p>
                                                    <p className="item-header total-header">Reward</p>
                                                </CustomBlock>
                                                {
                                                    bonusBuyOptions.map((option, index) =>
                                                        <CustomBlock
                                                            className="item-summary-line"
                                                        >
                                                            <p className="item">{option.level}</p>
                                                            <p className="item">${option.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                            <p className="total">${option.percentage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                        </CustomBlock>
                                                    )
                                                }
                                            </CustomBlock>
                                        </CustomBlock>
                                        <CustomBlock className="totals">
                                            <CustomBlock className="content-container">
                                                <ContentHeader
                                                    title="Purchase Totals"
                                                    headerSize="md"
                                                />
                                                <CustomBlock className="quote-header-summary">
                                                    <CustomBlock className="quote-header-block">
                                                        <CustomBlock className="cost-title">
                                                            <p className="total">Total</p>
                                                        </CustomBlock>
                                                        <CustomBlock className="cost-number">
                                                            <p className="total">${quote ? quote.bonusData.currentTotal.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}</p>
                                                        </CustomBlock>
                                                    </CustomBlock>

                                                    <CustomBlock className="quote-header-block">
                                                        <CustomBlock className="cost-title">
                                                            <p className="subtotal">Current Level Bonus</p>
                                                            <p className="subtotal">Bonus Buy Dollars Remaining</p>
                                                            <p className="subtotal">Amount Until Next Bonus</p>
                                                            <p className="subtotal">Next Level Bonus</p>
                                                        </CustomBlock>
                                                        <CustomBlock className="cost-number">
                                                            <p className="subtotal">{quote ? quote.bonusData.currentTotalBonus == 0 ? '--' : ('$' + quote.bonusData.currentTotalBonus.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")) : ''}</p>
                                                            <p className="subtotal">${quote ? quote.bonusData.currentRemainingBonus.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '0.00'}</p>
                                                            <p className="subtotal">{quote ? quote.bonusData.amountUntilNextBonus == 0 ? '--' : ('$' + quote.bonusData.amountUntilNextBonus.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")) : ''}</p>
                                                            <p className="subtotal">{quote ? quote.bonusData.nextBonusAmount == 0 ? '--' : ('$' + quote.bonusData.nextBonusAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")) : ''}</p>
                                                        </CustomBlock>
                                                    </CustomBlock>
                                                    <CustomBlock className="quote-header-block">
                                                        <p className="fw-700 darker-blue--clr" style={{ fontSize: 18 }}>Level Monthly Spending</p>
                                                        <CustomBlock style={{ width: '20%' }}>
                                                            <SelectBlock
                                                                defaultValue={Helper.SetOptionModel(levelMonths)}
                                                                options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(x => Helper.SetOptionModel(x))}
                                                                bordered
                                                                onChange={options => {
                                                                    options = options === null ? [] : options;
                                                                    UpdateLevelMonthsAndSpending(options.value);
                                                                    UpdateQuoteLevelMonths(options.value);
                                                                }}
                                                            />
                                                        </CustomBlock>
                                                    </CustomBlock>
                                                </CustomBlock>
                                            </CustomBlock>
                                        </CustomBlock>
                                    </CustomBlock>

                                    <CustomBlock className="audience-and-cpm-container">
                                        <SmallCard
                                            title="Audience Size"
                                            description={quote ? quote.bonusData.totalAudienceSize.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "--"}
                                            size="sm"
                                        />
                                        <SmallCard
                                            title="CPM"
                                            description={quote ? `$${quote.bonusData.cpm.toFixed(2)}` : "--"}
                                            size="sm"
                                        />
                                        <SmallCard
                                            title="Level Monthly Spending"
                                            description={`$${levelSpending.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`}
                                            size="sm"
                                        />
                                    </CustomBlock>

                                    <CustomBlock className="bonus-matrix">
                                        {
                                            quote?.products?.filter(x => x.product.whyChoseThisTactic && x.quantity > 0 && x.product.isActive).length === 0 ? <></> : (
                                                <ContentHeader
                                                    title="Why we chose this tactic"
                                                    headerSize="md"
                                                />
                                            )
                                        }

                                        {
                                            quote && quote.products.filter(x => x.quantity > 0 && x.product.isActive).map(x => x.product).map((product) => (
                                                product.whyChoseThisTactic && (
                                                    <>
                                                        <ContentHeader
                                                            title={product.name}
                                                            headerSize="sm"
                                                        />
                                                        <p>{product.whyChoseThisTactic}</p>
                                                        <br />
                                                    </>
                                                )
                                            ))
                                        }
                                    </CustomBlock>

                                    {/* MEDIA BUYS */}
                                    <CustomBlock className="summary-table">
                                        <CustomBlock className="media-buys-table">
                                            <MUIDataTable
                                                title={"Media Buy(s)"}
                                                data={normalBuys}
                                                // columns={_.concat(normalLogos, _.concat(columns, normalColumns))}
                                                columns={_.concat(columns, normalColumns)}
                                                options={options}
                                                className="w-100"
                                            />
                                        </CustomBlock>
                                    </CustomBlock>

                                    {/* BONUS BUYS */}
                                    <CustomBlock>
                                        <CustomBlock className="summary-table">
                                            <CustomBlock className="media-buys-table">
                                                <MUIDataTable
                                                    title={"Bonus Buy(s)"}
                                                    data={bonusBuys}
                                                    // columns={_.concat(bonusLogos, _.concat(columns, bonusColumns))}
                                                    columns={_.concat(columns, bonusColumns)}
                                                    options={options}
                                                    className="w-100"
                                                />
                                            </CustomBlock>
                                        </CustomBlock>
                                    </CustomBlock>

                                    {/* CHARTS */}
                                    <ContentHeader
                                        title="Charts and Statistics"
                                        headerSize="md"
                                    />
                                    <CustomBlock className="charts-container" style={{ marginBottom: 30 }}>
                                        <CustomBlock className="chart-block">
                                            <CustomBlock>
                                                <ContentHeader
                                                    title="Distribution of Media"
                                                    headerSize="sm"
                                                    containerStyle={{ justifyContent: "center" }}
                                                />
                                                <VictoryPie
                                                    theme={VictoryTheme.material}
                                                    data={mediaDistribution}
                                                    height={300}
                                                    x="media"
                                                    y="percentage"
                                                    labels={({ datum }) => ''}
                                                />
                                                <VictoryLegend
                                                    orientation="horizontal"
                                                    height={mediaDistribution ? (mediaDistribution.length * 20) : 100}
                                                    itemsPerRow={2}
                                                    gutter={20}
                                                    theme={VictoryTheme.material}
                                                    style={{ labels: { fontSize: 15 } }}
                                                    data={mediaDistribution ? _.map(mediaDistribution, function (x) { return { name: `${x.media} (~${x.percentage.toFixed(2)}%)` } }) : []}
                                                />
                                            </CustomBlock>
                                        </CustomBlock>
                                        <CustomBlock className="chart-block">
                                            <ContentHeader
                                                title="Spending By Media"
                                                headerSize="sm"
                                                containerStyle={{ justifyContent: "center" }}
                                            />
                                            <VictoryChart
                                                theme={VictoryTheme.material}
                                                domainPadding={20}
                                            >
                                                <VictoryAxis
                                                    tickFormat={mediaLabels}
                                                    style={{ tickLabels: { padding: 20, angle: -15 } }}
                                                    axisLabelComponent={<VictoryLabel dy={-12} />}
                                                />
                                                <VictoryAxis
                                                    dependentAxis
                                                    tickFormat={(x) => (`$${x / 1000}k`)}
                                                />
                                                <VictoryBar
                                                    data={spendingDistribution}
                                                    x="media"
                                                    y="spent"
                                                />
                                            </VictoryChart>
                                        </CustomBlock>
                                    </CustomBlock>

                                    {/* MONTHLY SPEND */}
                                    <Section fullWidth>
                                        <ContentBlock>
                                            <ContentHeader
                                                title="Monthly Spend"
                                                headerSize="md"
                                            />
                                        </ContentBlock>
                                        <ContentBlock>
                                            <CustomBlock style={{ overflow: 'auto' }}>
                                                <Table striped bordered hover>
                                                    <thead>
                                                        <tr>
                                                            {
                                                                durationOptions.map((x) => (
                                                                    <th>{x}</th>
                                                                ))
                                                            }
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            {
                                                                monthlySpendData.map((x, i) => (
                                                                    <td>${x.price.toFixed(2)}</td>
                                                                ))
                                                            }
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </CustomBlock>
                                        </ContentBlock>
                                    </Section>
                                    {/* SAMPLES SECTION */}
                                    <CustomBlock className="sample-media-container">
                                        <ContentHeader
                                            title="Sample Media"
                                            headerSize="md"
                                        />
                                        <CustomBlock className="content-block">
                                            <ImageGallery
                                                items={sampleImages}
                                                showPlayButton={false}
                                            />
                                        </CustomBlock>
                                    </CustomBlock>
                                </CustomBlock>
                            </Section>
                        </CustomBlock>

                        <Dialog
                            id="send-dialog"
                            open={showSend}
                            fullWidth="lg"
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Send Summary"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    <InputBlock
                                        id="campaignEmail"
                                        inputLabel="Email(s)"
                                        bordered
                                        onBlur={(e) => setEmail(e.target.value)}
                                    />
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <CustomBlock className="content-container--actions" style={{ paddingRight: 20, paddingBottom: 20 }}>
                                    <Button
                                        text="Close"
                                        className="danger--bg"
                                        onClick={() => setShowSend(false)}
                                    />
                                    <Button
                                        text="Send"
                                        className="success--bg"
                                        loading={sending}
                                        disabled={sending}
                                        onClick={
                                            () => {
                                                setSending(true);
                                                QuoteService.SendQuoteSummaryEmail(quote.id, email)
                                                    .then(res => {
                                                        setSending(false);
                                                        setShowSend(false);
                                                    })
                                                    .catch(ex => {
                                                        setSending(false);
                                                    });
                                            }
                                        }
                                    />
                                </CustomBlock>
                            </DialogActions>
                        </Dialog>
                    </>
            }
        </>
    )
}

export default CampaignSummaryPage;